const splitWithComma = date => `${date.slice(0, 10)}, ${date.slice(-4)}`

export function useDates() {
  let today = splitWithComma(new Date().toDateString())
  let lastDay = (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toDateString()
  let expires = splitWithComma(lastDay)

  return { today, expires }
}
export default useDates